var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vmp-aside-menu"},[(_vm.isLeLeInteractMode)?_c('AsideMenu2'):(_vm.isLiveCommerceMode)?_c('AsideMenu3'):_c('vmp-air-container',{attrs:{"cuid":_vm.cuid}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }